import React from 'react';
import { CustomButton, Loading } from '../_common';
import './LoadListItem.scss';
import { useAuthContext } from '../Auth/AuthProvider';
import { PermissionEnum } from '../../types/PermissionEnum';

interface LoadListItemProps {
    onClickAdd: () => void;
    onChangeRemove?: () => void;
    load: {
        id: number;
        driverName: string;
        tmsId: number;
    };
    onChange?: (checkedStatus: boolean) => void;
    isChecked: boolean;
    hasTmsValues: boolean;
    onClickRemoveDriver: () => void;
    errorMessage?: string;
    isDisabled?: boolean;
}

const LoadListItem = ({
    load,
    onClickAdd,
    hasTmsValues,
    onChange,
    isChecked,
    onClickRemoveDriver,
    errorMessage,
    isDisabled,
}: LoadListItemProps): React.ReactElement => {
    const canAddDriver = useAuthContext().userHasPermission(PermissionEnum.ManageLoads);
    const tmsIdValue = load!.tmsId && load!.tmsId > 0 ? `ID # ${load!.tmsId}` : '';
    const hasDriver = load!.driverName && load!.driverName.length > 0;
    const driverName = hasDriver ? load!.driverName : 'TBA';
    return (
        <div className="LoadListItem-Container">
            <div className="LoadListItem-Checkbox-Container">
                <input
                    key={load.id}
                    type="checkbox"
                    className="LoadListItem-Checkbox"
                    onChange={(event): void => onChange && onChange(event.currentTarget.checked)}
                    checked={isChecked}
                />
            </div>
            <div className="LoadListItem-Item">{load.id}</div>
            {hasTmsValues && <div className="LoadListItem-Item">{`${tmsIdValue}`}</div>}
            <div className="LoadListItem-Item">{driverName}</div>
            {isDisabled && hasDriver && (
                <div className="LoadListItem-Item-Loading">
                    <Loading />
                </div>
            )}
            {isDisabled && !hasDriver && <div className="LoadListItem-Item-Loading"></div>}
            {errorMessage && <div className="LoadListItem-Item-Error">{errorMessage}</div>}
            <div className="LoadListItem-ButtonContainer-Items">
                <div
                    className={`LoadListItem-ButtonContainer ${
                        isDisabled ? 'LoadListItem-ButtonContainer-Disable' : ''
                    }`}
                >
                    <CustomButton
                        title={hasDriver ? 'Change Driver' : 'Add Driver'}
                        isBordered
                        onClick={onClickAdd}
                        isDisabled={!canAddDriver}
                    ></CustomButton>
                </div>
                {hasDriver && (
                    <div
                        className={`LoadListItem-ButtonContainer ${
                            isDisabled ? 'LoadListItem-ButtonContainer-Disable' : ''
                        }`}
                    >
                        <CustomButton
                            title={'Remove Driver'}
                            isBordered
                            onClick={onClickRemoveDriver}
                            isDisabled={!canAddDriver}
                        ></CustomButton>
                    </div>
                )}
            </div>
        </div>
    );
};

export default LoadListItem;

